import {
  uidToColor
} from '../../utils/helpers'

import {
  fetchQueue
} from '../../utils/api'

export default {
  //
  //Session
  //
  getViewState(state) {
    return state.session ? state.session.view_state : 0
  },
  getState(state) {
    return state.session ? state.session.state : 0
  },
  newSession(state) {
    return state.session && !state.session.view_state ? state.session : null
  },
  getSession(state) {
    return state.session ? state.session : {}
  },
  getTotalTimeOn(state) {
    return state.session && state.session.time_on ? state.session.time_on : 0
  },
  getAgents(state) {
    return state.agents
  },
  getAgent(state) {
    //build agent data here when engaged
    if (!(state.agents && state.session && state.session.agent && state.agents[state.session.agent]))
      return null

    let agent = state.agents[state.session.agent]
    return {
        nickname: agent.nickname,
        avatar: agent.avatar,
        title: agent.title,
        agentBg: uidToColor(state.session.agent),
        initial: agent.nickname.substring(0,1)
    }

  },
  getMeta(state, getters) {
    return getters.getSession.meta || {}
  },
  getUser(state) {
    let user = {
      name: '',
      email: '',
      phone: '',
      avatar: ''
    }

    if (state.session && state.session.meta)
      for (var i in user)
        user[i] = state.session.meta[i] || ''

    let f = fetchQueue('getUser')
    if (f && typeof f[0] === 'function')
      f[0](user)

    return user
  },
}
